// extracted by mini-css-extract-plugin
export default {"table":"Games_table__ledd2","roundHeader":"Games_roundHeader__liGvc","anonymized":"Games_anonymized__US7VT"};